const resume = {
  name: "George Miracle Theophylus",
  title: "Software Engineer &\n Frontend Developer",
  phoneNumber: "(+62) 85377640809",
  website: {
    url: "https://georgemiracle.netlify.app",
    label: "georgemiracle",
  },
  email: {
    url: "georgemiracle2019@gmail.com",
    label: "georgemiracle2019@gmail.com",
  },
  linkedIn: {
    url: "https://www.linkedin.com/in/georgemiracle/",
    label: "linkedin.com/in/georgemiracle",
  },
  github: {
    url: "https://github.com/geoergemiraclee",
    label: "github.com/georgemiraclee",
  },
  location: "Indonesia",
  about:
    // "Skilled and diligent programmer with an eye for good designs. Always seeking to learn and improve on existing ways. A resourceful and avid self-learner passionate in coding.",
    "Accomplished and diligent software developer with a good eye for designs. Able to deliver products with high quality proven through customer satisfaction. Friendly, with strong communication skills with teammates. Seeking to learn and grow to become a professional software engineer.",

  skills: {
    languages: [
      "JavaScript",
      "HTML",
      "CSS",
      "PHP",
      "Python",
      "TypeScript",
      "Java",
      "SQL",
      "Kotlin"
    ],
    frontend: [
      "React",
      "Next",
      "Tailwind",
      "Redux",
      "Vue",
      "Svelte",
      "Material UI",
      "Bootstrap",
      "Figma",
    ],
    backend: [
      "Node.js",
      "Express",
      "CodeIgniter",
      "Laravel",
    ],
    database: ["MySQL","Firebase", "GraphQL"],
    devops: [
      "AWS",
      "Firebase",
      "Heroku",
      "Netlify",
      "Github Actions",
    ],
    others: [
      "Git",
      "NPM",
      "Postman",
      "Unity",
      "Adobe Premier Pro",
    ],
  },

  // Ukulele
  interests: ["Guitar", "Music", "Video Editor"],
  languages: ["English", "Indonesia", "Malay"],
  lastUpdated: "Feb 2024",
  education: {
    school: "Diponegoro University",
    cgpa: "3.68 / 4.0 (5th)", // Dean's List Scholar
    description:
      "Honours Bachelor of Engineering - Computer Engineering",
    timeline: "Expected 2025",
  },

  experiences: [
    {
      company: "JP Morgan Chase & Co",
      position: "Software Engineer Intern",
      timeline: "Dec 2023 - Feb 2024",
      location: "Remote",
      points: [
        "Create Frontend Interface with a stock price data feed and develop system for analysis of the data",
        "Implemented the Perspective open source code in preparation for data visualization",
        "Used Perspective to create the chart for the trader’s dashboard website",
      ],
    },
    {
      company: "Nore Inovasi",
      position: "Frontend Developer Part-Time",
      timeline: "October 2023 - December 2023",
      location: "Semarang, Indonesia",
      points: [
        "Create DERA Website using Next.Js , Material-UI",
        "Intergrating data from backend with API",
      ],
    },
    {
      company: "Akutahu",
      position: "Website Developer Intern",
      timeline: "August 2023 - December 2023",
      location: "South Jakarta, Jakarta, Indonesia",
      points: [
        "Maintance and Develop a New Feature in ISN Orchestra Website",
        "Bug Fixing and maintanace Admin Dashboard akutahu.com website using Codeigniter,PHP,Javascript,SQL",
      ],
    },
    {
      company: "MITGLOS",
      position: "Website Developer",
      timeline: "March 2023 - July 2023",
      location: "Central Jakarta, Jakarta, Indonesia",
      points: [
        "Make a Company Website",
        "Maintance, bug fixing , add some new content website",
        "Optimize website to become SEO Friendly",
      ],
    },
    {
      company: "Web Developer.",
      position: "Berani Digital",
      timeline: "March 2023 - Juny 2023",
      location: "Tangerang, Banten, Indonesia",
      points: [
        "Develop project with Laravel,PHP,Bootstrap",
        "Make a website and add some feature",
      ],
    },
    {
      company: "Frontend  Developer.",
      position: "Folkatech",
      timeline: "December 2022 - March 2023",
      location: "Bandung, Indonesia",
      points: [
        "Fixing Bug and Issues in Pressensi Website with Codeigniter, PHP, and Bootstrap",
        "Make and Develop a New Feature in Website Application",
        "Intergrating data from backend"
      ],
    },
    {
      company: "Frontend  Developer.",
      position: "Rakamin Academy",
      timeline: "November 2022 - January 2023",
      location: "East Jakarta, Jakarta, Indonesia",
      points: [
        "Develop Website With Vue.Js and Tailwind Css",
      ],
    },
  ],
  achievement: [
    {
      points: [
        "Awardee LPDP Kemendikbudristek S1 Dalam Negeri Beasiswa Indonesia Maju 2021",
        "Finalist Website Design Invention 2022",
        "Big 10Th Youth Agripreuneur Competition Astra Startups 2022 ",
      ],
    },
  ],
};

export default resume;
